"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var DebtActionButton = function (props) {
    return (React.createElement("div", { key: props.text, title: props.tip, onClick: function () { return (!props.disabled ? props.handleClick() : null); }, className: "debt-action-button debt-action-button-".concat(props.disabled ? 'disabled' : 'active') },
        props.icon,
        React.createElement("p", null, props.text)));
};
exports.default = DebtActionButton;
